let arrival_data7 = [
    {
        id : 24,
        imgurl : '/img/newarrival/section3_golf1.jpg',
        brand : 'HAZZYS GOLF',
        title : '블랙 다이나믹 냉감 긴팔 티셔츠',
        persent : '14%',
        price : '168,000',
        saleprice : '143,640',
    },
    {
        id : 25,
        imgurl : '/img/newarrival/section3_golf2.jpg',
        brand : 'HAZZYS GOLF',
        title : '화이트 어깨 포인트 소프트 반팔 카라티',
        persent : '5%',
        price : '258,000',
        saleprice : '245,100',
    },
    {
        id : 26,
        imgurl : '/img/newarrival/section3_golf3.jpg',
        brand : 'MONTBELL',
        title : '위크론 폴로 셔츠 남 WHITE',
        persent : '',
        price : '',
        saleprice : '69,000',
    },
    {
        id : 27,
        imgurl : '/img/newarrival/section3_golf4.jpg',
        brand : 'DRUHGOLF',
        title : '드루 남성 하이클로 체크 팬츠',
        persent : '5%',
        price : '219,000',
        saleprice : '208,050',
    },
]

export default arrival_data7